// src/pages/product/DailyBriefPage.js
import FeaturePageTemplate from './FeaturePageTemplate';

export default function DailyBriefPage() {
  return <FeaturePageTemplate slug="daily-brief" />;
}